import { Dialog } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { ReactComponent as OrangeRefund } from '../../../assets/images/orangeRefund.svg';
import { AlertStatusCard } from "../../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import { OrderActionButtons } from "../OrderDetailsUI/OrderActionButtons";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../../services/API";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import { PreferredContact } from "../constants";
import { useTranslation } from "react-i18next";
import { RefundReasons, RefundType } from "../PartialRefund/types";
import { useDialogRouteStages } from "../../dialogRoutes/useDialogRouteStages";
import { dialogKeys } from "../../../const/URL.const";
import { useSnackbarMessages } from "../../../yoello-lib/modules/components/snackbar/SnackbarContext";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    venueId: string;
    inOrderIds: Record<string, number>;
    orderId: string;
    consumer: any;
    history: any;
    // Refunding or Declining
    isRefund:boolean;
}
const useStyles = makeStyles({
    title: {
        color: "#FA7800",
        fontSize: "1rem",
        fontWeight: 600,
        padding: "0 1rem"
    },

    root: {
        padding: 0,
        '& .MuiDialog-paper':{
            padding:0
        },
        "& header": {
            "& >div:last-child": {
                position: "absolute",
                right: "2.5rem",
                top: "1.25rem"
            },
            background: "#FFFFFF",
            alignItems: "center",
            padding: "1.875rem 2.5rem 1.25rem 2.5rem",
            display: "flex",
            justifyContent: "center",

        },
        "& body": {
            padding: "0 3.75rem",
            backgroundColor: "#FFFFFF",
            marginBottom:"1.875rem"
        },
        "& footer": {
            padding: "0 3.75rem",
            backgroundColor: "#F3F4F9",
            alignItems: "center",
            display: "flex",
            flexDirection: " column",
            "& button":{
                padding:"0.625rem 1.875rem!important",
                margin:"0 0.625rem"
            }
        }
    },
    details: {
        fontSize: "0.925rem",
        padding: "0 1rem"
    },
    labelText: {
        color: "#757575",
    },
    rowItem: {
        display: "flex",
        justifyContent: "space-between",
        "& >p": {
            margin: "0.1rem",
            padding: "0.1rem 0"
        }
    },
    status: {
        marginTop: "1rem"
    },
    actionText: {
        margin: "1rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        fontSize: "0.95rem",
        "& >p": {
            margin: 0,
            padding: 0
        }
    },
    actionBtn: {
        margin: "1rem",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",

    }
})


export function OBRefundDialog({ isOpen, onClose, venueId, inOrderIds, orderId, consumer , history,isRefund }: IProps) {
    const { t } = useTranslation();
    const { root, title, labelText, details, rowItem, status , actionText, actionBtn } = useStyles();
    const { getProps, setProps  , closeAllModals } = useDialogRouteStages(history);
    const { callAPI: callPlacedOrders } = useAPIV2(APIExtensions.placedOrders, { onMountDisabled: true });
    const { url , orderAPICall, path: OriginPath , setMessageOptions } = getProps(dialogKeys.ORDER);
    const { sendSnackbarMessage } = useSnackbarMessages()!;
  async function onDeclineOrder() {
        try{
            let response;
            if(isRefund){
                response =  await callPlacedOrders(HTTPMethods.POST, {
                    query: `${orderId}/refunds`,
                    body: {
                        venue_id: venueId,
                        refund_type: RefundType.FULL,
                        reason: "OTHER",
                        in_order_ids: inOrderIds,
                        order_details_url: url,
                        include_extras: true
                    },
                })
            }else{
                response = await callPlacedOrders(HTTPMethods.POST, {
                    query: `${orderId}/decline`,
                    body:{
                      venue_id: venueId,
                      reason:RefundReasons.OTHER ,
                      order_details_url: url
                    },
                  });
            }
            if (response.isSuccessful) {
                if(orderAPICall){
                    orderAPICall(HTTPMethods.GET);
                }else if(setMessageOptions){
                    setMessageOptions(true)
                }
                onClose();
                closeAllModals(OriginPath)
                setProps(dialogKeys.ORDER, "refundType", undefined);
                setProps(dialogKeys.ORDER, "reason", undefined);
              }else{
                sendSnackbarMessage("you cant refund","error")
              }
        }catch(err){
            sendSnackbarMessage("you cant refund","error")
        }
    }
    return <Dialog open={isOpen} onClose={onClose} maxWidth="xs" className={root} >
        <header data-testid="dialog-appbar">
            <div>
                <OrangeRefund />
            </div>
            <div>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={onClose}
                    aria-label="close"
                    data-component-name="DialogCloseButton"
                >
                    <CloseIcon />
                </IconButton>
            </div>
        </header>
        <body>
            <div className={title}>
                <p>
                    {t('openBanking.refund.title1')}
                </p>
                <p>
                    {t('openBanking.refund.title2')}
                </p>
            </div>
            <div className={details}>
                <p className={labelText}>{t('openBanking.refund.details')}</p>
                <div className={rowItem}>
                    <p className={labelText}>{t('openBanking.refund.name')}</p>
                    <p>{consumer.consumer_first_name} {consumer.consumer_last_name}</p>
                </div>
                <div className={rowItem}>
                    <p className={labelText}>{t('openBanking.refund.contact')}
                    </p>
                    <p>{consumer.consumer_contact_preference === PreferredContact.Email ? consumer.consumer_contact_email
                        : consumer.consumer_contact_phone}</p>
                </div>
                <div className={status}>
                    <AlertStatusCard alertTitle={<b>{t('openBanking.refund.status.title')}</b>}
                        alertProps={{ severity: "info" }} alertMessage={t('openBanking.refund.status.info')}
                    />
                </div>
            </div>
        </body>
        <footer>
            <div className={actionText}>
                <p>
                    {t('delete.items.content1')}
                </p>
                <p><b>{t('delete.items.content2')}</b></p>
            </div>
            <div className={actionBtn}>
                <OrderActionButtons colour={'#FFFFFF'} fontColour={"black"} onClick={onClose} label={t('delete.cancel')} />
                <OrderActionButtons isRefund={isRefund} colour={"rgba(250, 120, 0, 0.25)"} fontColour={"#fa7800"} onClick={onDeclineOrder} label={t('delete.confirm')} />
            </div>
        </footer>
    </Dialog>
}
